import {Component, OnInit, Optional} from '@angular/core';
import {FormBuilder, Validators} from "@angular/forms";
import {TableHeaderService} from '../../services/table-header.service';
import {LoaderService} from '../../services/loader.service';
import {ActionService} from '../../services/action.service';
import {ITableHeader} from '../../../interfaces/table-header';
import {TableEntityExtension} from "../../extensions/table-entity-extension/table-entity.extension";
import {TableEntityExtensionService} from "../../extensions/table-entity-extension/table-entity-extension.service";
import {ActivatedRoute} from "@angular/router";
import {CardService} from "../../components/card/card.service";
import {FormService} from "../../services/form.service";
import {GuardService} from "../../services/guard.service";

@Component({
  selector: 'table-action',
  templateUrl: './table-action.component.html',
  providers: [LoaderService]
})
export class TableActionComponent extends TableEntityExtension implements OnInit {
  headers: ITableHeader[];

  query: any = {
    filters: {},
   order: null,
    relations: ['store', 'product']
  };

  constructor(public loaderService: LoaderService,
              protected route: ActivatedRoute,
              protected modelService: ActionService,
              protected tableEntityExtensionService: TableEntityExtensionService,
              @Optional() protected cardService: CardService,
              private tableHeaderService: TableHeaderService,
              private formService: FormService,
              private guardService: GuardService) {
    super(
      modelService,
      cardService,
      loaderService,
      tableEntityExtensionService,
      route
    );
  }

  ngOnInit(): void {
    this.headers = [
      this.tableHeaderService.id(),
      this.tableHeaderService.key(),
      this.tableHeaderService.store(),
      this.tableHeaderService.product({filter: {
          storeQuery: (this.query.filters.store || this.query.filters.parentStore) ? {
            parentStore: this.query.filters.store || this.query.filters.parentStore
          } : null
        }}),
      this.tableHeaderService.active({sort: false}),
      // this.tableHeaderService.platform({sort: false, filter: false}),
      this.tableHeaderService.createdAt(),
      this.tableHeaderService.updatedAt(),
    ];
    this.checkChanges();
    this.routesInit('actions');
  }

  async initForm(itemCollapse: any) {
    const skipChanges = await this.guardService.skipChanges();

    if (!skipChanges || itemCollapse.result) return;

    const item = this.source[itemCollapse.position];
    const form = this.forms[item.id] = new FormBuilder().group({
      name: [null, Validators.required],
      key: [null, Validators.required],
      product: [null],
      circle: [null, [Validators.required, Validators.min(0)]],
      timeOut: [null, Validators.min(0)],
      active: [],
      multiple: [],
      apple: [],
      google: [],
    });

    form.patchValue(item);
    this.formService.setDefaultValues(form);
    this.formService.setActiveForms([form]);

    itemCollapse.next();
  }

  async cancel(collapse) {
    const skipChanges = await this.guardService.skipChanges();
    if (skipChanges) this.formService.setForceSkipCheck()
    if (!skipChanges || collapse.result) return;

    collapse.toggle();
  }
}
